var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"org-index-box"},[(_vm.page === 1)?_c('org-index'):(_vm.page===4)?_c('edit-org-name'):(_vm.page===7)?_c('del-org-item'):(_vm.page===8)?_c('tranfer-org-first'):(_vm.page===9)?_c('tranfer-org-second'):_c('org-index')],1)}
var staticRenderFns = []

export { render, staticRenderFns }